// var to check the device
var IsMobile = (function() {
    var Android = function() {
        return navigator.userAgent.match(/Android/i);
    };

    var BlackBerry = function() {
        return navigator.userAgent.match(/BlackBerry/i);
    };

    var iOS = function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    };

    var Opera = function() {
        return navigator.userAgent.match(/Opera Mini/i);
    };

    var Windows = function() {
        return navigator.userAgent.match(/IEMobile/i);
    };

    var any = function() {
        return (Android() || BlackBerry() || iOS() || Opera() || Windows());
    };

    return {
        any: any
    };
})();

var backToTopSel = '.j-back-to-top';

$(window).on('scroll', function () {
    if($(backToTopSel).length > 0){
        if ($(this).scrollTop() > 150) {
            $(backToTopSel).fadeIn(1000); // Fading in the button on scroll after 150px
        } else {
            $(backToTopSel).fadeOut(500); // Fading out the button on scroll if less than 150px
        }
    }
});

$(document).ready(function () {
    $(backToTopSel).on('click', function (e) {
        $('body, html').animate({scrollTop: 0}, 600);
    });
});


// constructor for create the BOX, which is working with popup windows (background div).
function BackgroundBox(className, content, parent) {

    this.parent = parent || document.body;

    this.domElement = document.createElement('div');//background wrapper
    this.className = className;
    this.domElement.classList.add(this.className);

    var contInfoWindow = document.createElement('div');// wrapper for content
    contInfoWindow.innerHTML = content;//add content in the div
    this.domElement.appendChild(contInfoWindow);

    //styles for the parent div
    this.domElement.style.opacity = '0';
    this.domElement.style.width = '100%';
    this.domElement.style.height = '100%';
    this.domElement.style.position = 'fixed';
    this.domElement.style.textAlign = 'center';
    this.domElement.style.top = 0;
    this.domElement.style.left = 0;
    this.domElement.style.zIndex = 1150;
    this.domElement.style.background = 'rgba(51, 51, 51, 0.65)';
    this.domElement.style.transition = 'opacity 0.3s ease-in-out';

    //styles for wrapper of content
    contInfoWindow.style.display = 'inline-block';
    contInfoWindow.style.background = 'rgb(255, 255, 255)';
    contInfoWindow.style.padding = '10px 15px';
    contInfoWindow.style.borderRadius = '5px';
    contInfoWindow.style.maxWidth = '80%';
    contInfoWindow.style.margin = '0 auto';
    contInfoWindow.style.position = 'relative';
    contInfoWindow.style.textAlign = 'center';
    contInfoWindow.style.boxShadow = '0px 4px 8px 0px #333';

    this.parent.appendChild(this.domElement);
    contInfoWindow.style.top = 'calc(50% - ' + (contInfoWindow.offsetHeight / 2) + "px)"; //only after append the element in the DOM, we will know his height


}

//function for hide of parent element with children
BackgroundBox.prototype.hide = function() {
    this.domElement.style.opacity = "0";
    var wrapper = this.domElement;
    setTimeout(function () {
        wrapper.parentNode && wrapper.parentNode.removeChild(wrapper)
    }, 100); //timeout for animation
};

//function for delay
BackgroundBox.prototype.hideWithDelay = function(delay) {
    delay = delay || 1000;
    setTimeout(this.hide.bind(this), delay);
};

//function for show
BackgroundBox.prototype.show = function() {
    this.domElement.style.opacity = "1";
};

// function for navigation
var CustomNavigationThemeFunction = (function ($) {

    function init() {
        var topNavigationList = $('.nav .dropdown a');
        if (topNavigationList.length) {
            var locationPath = window.location.pathname;
            var arrayOfLinks = topNavigationList;
            for (var i = 0; i < arrayOfLinks.length; i++){
                var link = $(arrayOfLinks[i]);
                if (locationPath === link.attr('href')){
                    link.addClass('selected-link');
                    link.closest('.dropdown .dropdown-toggle').addClass('current-locate');
                    break;
                }
            }
            $(".navbar-nav .dropdown").hover(function () {
                if ($(window).width() > 744) {
                    elementMenuResize(this);
                }
            });
        }
    }

    function initNavigation (){
        //Show/hide navigation on mobiles
        $('#burger-nav').on('click', function () {
            $('#burger-nav').toggleClass("open");
            $('.top-navigation').toggleClass("open");
        });

        if (IsMobile.any() || $(window).width() < 767) {
            // If a link has a dropdown, add sub menu toggle.
            $('nav ul li a.has-sublist').on('click', function (e) {

                e.preventDefault();

                if ($(window).width() < 767) {
                    $('.has-sublist').not($(this)).removeClass('active');
                    $(this).toggleClass('active');
                    $(this).siblings('.dropdown-menu').toggle();
                    // Close one dropdown when selecting another
                    $('.dropdown-menu').not($(this).siblings()).hide();
                } else {
                    $(this).siblings().css({'display': ''});
                }

            });
        }
    }

    function allMenuResize() {
        [].forEach.call($('.navbar-nav .dropdown'), function (el) {
            elementMenuResize(el);
        });
    }

    function elementMenuResize(rootElement) {
        var subList = rootElement.getElementsByClassName('dropdown-menu');
        if (subList.length) {
            var element = subList[0];
            var elementWidth = element.clientWidth;
            if (elementWidth > 0) {
                var positionLeft = rootElement.getBoundingClientRect().left;
                var styleLeft = $(window).width() - elementWidth - positionLeft;
                if (positionLeft + elementWidth > $(window).width()) {
                    element.style.left = ((positionLeft + styleLeft < 0) ? "-" + positionLeft : styleLeft) + "px";
                }
            }
        }
    }

    return {
        init: init,
        initNavigation: initNavigation,
        allMenuResize: allMenuResize
    }
})(jQuery);

var splitMenuOptions = (function ($) {

    function splitColumns() {

        $(".navbar-nav .dropdown").hover(function () {
            if ($(this).hasClass("rd2021")) {
                return;
            }
            if ($(window).width() >= 744) {

                $(this).addClass("open");
            }
        },
        function () {
            $(this).removeClass("open");
        });
    }

    return {
        splitColumns: splitColumns,
    };

})(jQuery);

$(document).ready(function () {

    splitMenuOptions.splitColumns();

    CustomNavigationThemeFunction.init();
    CustomNavigationThemeFunction.initNavigation();

    $(window).on('resize', function () {
        if ($(window).width() > 744) {
            CustomNavigationThemeFunction.allMenuResize();
        }
    });
});

